// components/LanguageFloatingGroup.jsx
import React, { useContext, useState, useEffect } from 'react';
import { FloatButton } from 'antd';
import { Context } from '../context';
import { setStoredLanguage, LANGUAGES, getStoredLanguage } from '../helpers/i18n';

const LanguageFloatingGroup = ({ 
  shape = 'circle',
  offset = { x: 20, y: 20 },
}) => {
  const { language, setLanguage } = useContext(Context);
  const [currentLang, setCurrentLang] = useState(language || getStoredLanguage());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setCurrentLang(language || getStoredLanguage());
  }, [language]);

  const handleLanguageChange = (langCode) => {
    setStoredLanguage(langCode);
    setCurrentLang(langCode);
    if (setLanguage) {
      setLanguage(langCode);
    }
    setOpen(false);
    window.location.reload();
  };

  const getFlagEmoji = (langCode) => {
    switch(langCode) {
      case 'IT': return '🇮🇹';
      case 'EN': return '🇬🇧';
      default: return '🌐';
    }
  };

  const getLanguageLabel = (langCode) => {
    switch(langCode) {
      case 'IT': return 'Italiano';
      case 'EN': return 'English';
      default: return langCode;
    }
  };

  // Ottieni la lingua opposta (quella non selezionata)
  const getOppositeLanguage = () => {
    return LANGUAGES.find(lang => lang !== currentLang) || 'EN';
  };

  const oppositeLang = getOppositeLanguage();

  // Icone per i bottoni del gruppo - mostra solo la lingua opposta
  const languageIcons = [{
    icon: <span style={{ fontSize: '20px' }}>{getFlagEmoji(oppositeLang)}</span>,
    tooltip: getLanguageLabel(oppositeLang),
    onClick: () => handleLanguageChange(oppositeLang),
    type: 'default',
  }];

  return (
    <div
      style={{
        position: 'fixed',
        bottom: offset.y + 'px',
        left: offset.x + 'px',
        zIndex: 9999,
      }}
    >
      <FloatButton.Group
         shape={shape}
         open={open}
         className='language-button-flag'
         placement='right'
         onOpenChange={setOpen}
         trigger="click"
         icon={getFlagEmoji(currentLang)}
         closeIcon={getFlagEmoji(currentLang)}
      >
        {languageIcons.map((item, index) => (
           <FloatButton
            className='language-button-flag'
            key={index}
            icon={item.icon}
            tooltip={item.tooltip}
            onClick={item.onClick}
            type={item.type}
          />
        ))}
      </FloatButton.Group>
    </div>
  );
};

export default LanguageFloatingGroup;